import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IPicture } from '@finder/shared/components/picture/picture.interface';
import { PictureComponent } from '../picture/picture.component';

/**
 * Hero Media is used to display gallery, desktop or mobile picture or video.
 *
 * <finder-hero-media [picture]="Picture"></finder-hero-media>
 */
@Component({
    selector: 'finder-hero-media',
    templateUrl: './hero-media.component.html',
    styleUrls: ['./hero-media.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        PictureComponent
    ]
})
export class HeroMediaComponent {

    /**
     * @member {IPicture} picture The picture object that holds the desktop and mobile image
     */
    @Input() picture: IPicture;
    // TODO Future inputs
    // @Input('video') video: any;
    // @Input('gallery') gallery: any;

    loadingType = 'eager';

    constructor() { }

}
